const delay = (t: number) => new Promise((resolve) => setTimeout(resolve, t));
export default delay;
